import React from 'react';

const IcTwitterBase64 = () => {
  return (
    <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43NSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMTAiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNC4yIDQuNTYyNUgxNi4wNDA1TDEyLjAyMDUgOS4xNjlMMTYuNzUgMTUuNDM3NUgxMy4wNDcyTDEwLjE0NyAxMS42MzVMNi44MjgyNSAxNS40Mzc1SDQuOTg3TDkuMjg2NzUgMTAuNTFMNC43NSA0LjU2MjVIOC41NDcyNUwxMS4xNjg1IDguMDM3MjVMMTQuMiA0LjU2MjVaTTEzLjU1NSAxNC4zMzM1SDE0LjU3NUw3Ljk5MjI1IDUuNjA4NzVINi44OTg3NUwxMy41NTUgMTQuMzMzNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=" />
  );
};

export default IcTwitterBase64;
